export var LIVE_NEWS = "LIVE_NEWS";
export var EQUITY_HOLDING_LIVE_NEWS = "EQUITY_HOLDING_LIVE_NEWS";
export var LIVE_NEWS_ERROR = "LIVE_NEWS_ERROR";
export var LIVE_NEWS_HIDE_ERROR = "LIVE_NEWS_HIDE_ERROR";
export var LIVE_NEWS_START_LOADER = "LIVE_NEWS_START_LOADER";
export var LIVE_NEWS_STOP_LOADER = "LIVE_NEWS_STOP_LOADER";
export var QOUTE_STREAM_NEWS = "QOUTE_STREAM_NEWS";
export var LIVE_NEWS_STREAM = "LIVE_NEWS_STREAM";
export var RESET_STREAM_COUNT = "RESET_STREAM_COUNT";
export var CLEAR_DATA = "CLEAR_DATA";
